
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>
Le coronavirus tient actuellement le monde en haleine. Et l'épidémie de grippe saisonnière ainsi que les rhumes font rage chaque année. Pourtant, il serait relativement facile de tenir ces agents pathogènes à l'écart: lavez-vous les mains! Et faites-le correctement. Mais, ce n'est pas si simple.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;